<template>
  <button
    :type="type"
    class="relative rounded-lg bg-primary px-3 py-1 text-lg text-primary-fg disabled:pointer-events-none disabled:opacity-40"
    :disabled="isLoading || disabled"
  >
    <slot> Save </slot>
    <BaseInnerLoading v-if="isLoading" />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    type?: "button" | "submit"
    isLoading?: boolean
    disabled?: boolean
  }>(),
  {
    type: "submit",
  }
)
</script>
